<style>
.comment-modal-wide {
  max-width: 80vw !important;
}
.table .comment-origin-row {
  background-color: #eaf1fb !important;
}
</style>

<!-- 피드 상세 페이지 -->
<template>
  <div id="app">
    <NavComponent />
    <b-container v-if="feedData != null">
      <b-row>
        <b-col class="nameFields" cols="2">
          user_email:
          <!-- 고정 -->
        </b-col>
        <b-col class="feedData" cols="8">
          <b-button @click="openAdminUserPage(feedData.user.email)">
            {{ feedData.user.email }}
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          content_type:
          <!-- 고정 -->
        </b-col>
        <b-col class="feedData" cols="8">
          {{ feedData.feedpost.content.type }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          created_at:
          <!-- 고정 -->
        </b-col>
        <b-col class="feedData" cols="8">
          {{ getTimeStamp(feedData.feedpost.created_at) }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          content:
          <!-- 수정가능 -->
        </b-col>
        <b-col class="feedData" cols="8">
          <b-form-textarea
            id="textarea"
            v-model="changedFeedContent"
            :placeholder="feedData.feedpost.content.text"
            rows="3"
            max-rows="6"
          >
          </b-form-textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          comments:
          <!-- 고정 -->
        </b-col>
        <b-col class="feedData" cols="8">
          <b-button
            :disabled="!feedData.feedpost.total_count_comments"
            @click="
              getComments(feedData.feedpost.feedpost_id),
                $bvModal.show('commentModal')
            "
          >
            {{ feedData.feedpost.total_count_comments }}
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          total_likes:
          <!-- 고정 -->
        </b-col>
        <b-col class="feedData" cols="8">
          {{ feedData.feedpost.total_count_likes }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          manage_likes:
          <!-- 수정 가능 -->
        </b-col>
        <b-col class="feedData" cols="8">
          <b-form-input
            id="input-small"
            size="sm"
            :placeholder="String(feedData.feedpost.total_count_manage_likes)"
            v-model="changedManageLikesCount"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          reports:
          <!-- 고정 -->
        </b-col>
        <b-col class="feedData" cols="8">
          {{ feedData.feedpost.total_count_reports }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="nameFields" cols="2">
          hide:
          <!-- 수정 가능 // enum-->
        </b-col>
        <b-dropdown id="dropdown-1" :text="currentHideType" class="m-md-2">
          <b-dropdown-item @click="changeHideType('none')"
            >none</b-dropdown-item
          >
          <b-dropdown-item @click="changeHideType('전체숨김')"
            >전체숨김</b-dropdown-item
          >
          <b-dropdown-item @click="changeHideType('신고누적숨김')"
            >신고누적숨김</b-dropdown-item
          >
          <b-dropdown-item @click="changeHideType('작외숨')"
            >작외숨</b-dropdown-item
          >
        </b-dropdown>
      </b-row>

      <b-row>
        <b-col class="isDeleteFields" cols="2">
          isDelete:
          <!-- 수정 가능 // enum-->
        </b-col>
        <b-dropdown id="dropdown-5" :text="currentDeleteType" class="m-md-2">
          <b-dropdown-item @click="changeIsDelete('true')"
            >true</b-dropdown-item
          >
          <b-dropdown-item @click="changeIsDelete('false')"
            >false</b-dropdown-item
          >
        </b-dropdown>
      </b-row>

      <b-row>
        <b-col class="nameFields" cols="2">
          content_url:
          <!-- 삭제가능 -->
        </b-col>
        <b-col class="feedData" cols="8">
          <div v-if="feedData.feedpost.content.type == 'GIF'">
            <b-img
              :src="feedData.feedpost.content.url[0]['url']"
              style="max-height: 300px; width: auto; cursor: pointer;"
              @click="openImagePreview([feedData.feedpost.content.url[0]])"
            />
          </div>
          <div v-else-if="feedData.feedpost.content.type == 'AUDIO'">
            <audio
              controls
              :src="feedData.feedpost.content.url[0]['url']"
            ></audio>
            <br />
            {{ feedData.feedpost.content.url[0] }}
          </div>
          <div v-else-if="feedData.feedpost.content.type == 'IMAGE'">
            <div style="display: flex; overflow-x: auto; gap: 8px;">
              <b-img
                v-for="(imageUrl, index) in feedData.feedpost.content.url"
                :key="index"
                :src="imageUrl.url"
                style="max-height: 300px; width: auto; flex-shrink: 0; cursor: pointer;"
                @click="openImagePreview(feedData.feedpost.content.url)"
              />
            </div>
          </div>
          <div v-else-if="feedData.feedpost.content.type == 'CALL_ROOM'">
            <b-button @click="openCallRoomPage(feedData.feedpost.content.url[0].id)">
              {{ feedData.feedpost.content.url[0].id }}
            </b-button>
          </div>

        
        </b-col>
      </b-row>

      <!-- 댓글 가져오기 모달 -->
      <b-modal id="commentModal" hide-footer size="xl" dialog-class="comment-modal-wide">
        <template #modal-title>
          {{ feedOriginId.substring(0, 8) }}...
          <div style="font-size: small;">
            <b-span>선택된 댓글  {{ Object.keys(selectedComments).filter(
                (key) => selectedComments[key] === "accepted"
              ).length }}개</b-span>

            <b-dropdown
              id="dropdown-hide-comment"
              :text="commentDropdownHideType"
              class="m-md-2"
            >
              <b-dropdown-item @click="changecommentDropdownHideType('none')">none</b-dropdown-item>
              <b-dropdown-item @click="changecommentDropdownHideType('전체숨김')">전체숨김</b-dropdown-item>
              <b-dropdown-item @click="changecommentDropdownHideType('신고누적숨김')">신고누적숨김</b-dropdown-item>
              <b-dropdown-item @click="changecommentDropdownHideType('작외숨')">작외숨</b-dropdown-item>
            </b-dropdown>
            <b-button class="mr-2" size="sm" :disabled="Object.keys(selectedComments).filter(k => selectedComments[k] === 'accepted').length === 0" @click="hideCommentActionButton()">
              액션
            </b-button>
          </div>
        </template>
        <b-table
          hover
          :items="comments"
          :fields="commentTableFields"
          small
          fixed
          style="word-break: break-all; cursor: pointer;"
          :tbody-tr-class="commentRowClass"
          @row-clicked="(item) => commentCheckboxChange(item.id)"
        >
          <template #head(selected)>
            <b-form-checkbox
              :checked="comments.length > 0 && Object.keys(selectedComments).filter(k => selectedComments[k] === 'accepted').length === comments.length"
              @change="toggleSelectWholeComments()"
            />
          </template>
          <template #cell(selected)="row">
            <b-form-checkbox
                :checked="selectedComments[row.item.id] === 'accepted'"
                @change="commentCheckboxChange(row.item.id)"
            ></b-form-checkbox>
          </template>
          <template #cell(comment)="row">
            {{ row.item.comment ? row.item.comment : "-" }}
            <b-badge v-if="reportedCommentId && String(row.item.id) === String(reportedCommentId)" variant="danger" class="ml-1">신고대상</b-badge>
          </template>
          <template #cell(id)="row">
            <b-button
              size="sm"
              class="mr-2"
              @click="openFeedComment(row.item.uuid, row.item.id)"
            >
              {{ row.item.id.substring(0, 8) }}...
            </b-button>
          </template>
          <template #cell(user)="row">
            <b-button
              size="sm"
              class="mr-2"
              @click="openAdminUserPage(row.item.user)"
            >
              {{ row.item.user.split("@")[0] }}
            </b-button>
          </template>
          <template #cell(content)="row">
            <div style="word-break: break-all">
              <template v-if="row.item.content && row.item.content.length > 30">
                {{ row.item._textExpanded
                  ? row.item.content
                  : row.item.content.substring(0, 30) + '...' }}
                <b-link @click.stop="$set(row.item, '_textExpanded', !row.item._textExpanded)">
                  {{ row.item._textExpanded ? '접기' : '더보기' }}
                </b-link>
              </template>
              <template v-else>
                {{ row.item.content }}
              </template>
            </div>
          </template>
          <template #cell(contentPreview)="row">
            <audio
              v-if="row.item.content_type === 'AUDIO' && row.item.contentUrl && row.item.contentUrl.length > 0"
              controls
              preload="none"
              :src="row.item.contentUrl[0].url"
              style="max-width: 200px"
            ></audio>
            <span v-else>-</span>
          </template>
          <template #cell(is_delete)="row">
            <b-icon :icon="row.item.is_delete ? 'check-circle' : 'x-circle'" :variant="row.item.is_delete ? 'success' : 'danger'"></b-icon>
          </template>
        </b-table>
        <b-button class="mt-3" block @click="$bvModal.hide('commentModal')"
          >닫기</b-button
        >
      </b-modal>
    </b-container>
    <b-container fluid v-if="feedData != null">
      <b-row>
        <div class="profileExchangeHeader">
          <h1 style="margin: 0;">프로필 교환 신청</h1>
        </div>
        <b-table
          hover 
          :items="profileExchanges" 
          :fields="profileExchangesTableFields"
          small
        >
          <template #cell(id)="row">
            <b-link
              class="clickableId"
              :href="row.item.url"
              target="_blank"
            >
              {{row.item.id}}
            </b-link>
          </template>

          <template #cell(targetUser_responded_at)="row">
            {{row.item.targetUser_responded_at ? formatDateTime(row.item.targetUser_responded_at) : "-"}}
          </template>

          <template #cell(user_requested_at)="row">
            {{row.item.user_requested_at ? formatDateTime(row.item.user_requested_at) : "-"}}
          </template>

          <template #cell(comment)="row">
            {{row.item.comment ? row.item.comment : "-"}}
          </template>
        </b-table>
      </b-row>

      <b-button style="margin-right: 10px" @click="updateFeedContent()"
        >UPDATE</b-button
      >
      <b-button style="margin-left: 10px" @click="deleteFeedContent()"
        >DELETE</b-button
      >
    </b-container>
    <ImagePreviewModal modalId="feedContentImagePreview" :images="previewImages" />
  </div>
</template>

<script>
import NavComponent from "./NavComponent.vue";
import ImagePreviewModal from "./ImagePreviewModal.vue";

export default {
  name: "FeedContent",
  components: {
    NavComponent,
    ImagePreviewModal,
  },
  data() {
    return {
      feedData: null,
      currentHideType: null,
      currentDeleteType: null,
      changedManageLikesCount: null,
      changedFeedContent: null,
      comments: [],
      feedOriginId: "",
      reportedCommentId: null,
      selectedComments: {},
      commentDropdownHideType: "none",
      hideCategory: {
        "none": "NONE",
        "전체숨김": "CS",
        "신고누적숨김": "REPORT",
        "작외숨": "OWN"
      },
      commentTableFields: [
        {key:"selected", label:"", thStyle: { width: "40px" }},
        {key:"comment", label:"종류", thStyle: { width: "60px" }},
        {key:"id", label:"id", thStyle: { width: "90px" }},
        {key:"user", label:"작성자", thStyle: { width: "100px" }},
        {key:"content_type", label:"유형", thStyle: { width: "80px" }},
        {key:"content", label:"text"},
        {key:"contentPreview", label:"미리보기", thStyle: { width: "220px" }},
        {key:"likesCount", label:"좋아요", thStyle: { width: "55px" }},
        {key:"reportsCount", label:"신고", thStyle: { width: "55px" }},
        {key:"is_delete", label:"삭제", thStyle: { width: "50px" }},
        {key:"hide", label:"숨김", thStyle: { width: "100px" }},
        {key:"created_at", label:"작성일", thStyle: { width: "140px" }},
      ],
      previewImages: [],
      loginCountry: this.$session.get("country"),
      apiBaseUrl: "",
      postId: null,
      profileExchanges: [],
      profileExchangesTableFields: [
        { key: 'id', label: 'ID' },
        { key: 'user.email', label: '발신자' },
        { key: 'user_status', label: '발신자 교환 상태' },
        { key: 'user_requested_at', label: '신청 일자' },
        { key: 'targetUser.email', label: '수신자' },
        { key: 'targetUser_status', label: '수신자 교환 상태' },
        { key: 'targetUser_responded_at', label: '응답 일자' },
        { key: 'comment', label: '신청 피드 댓글' }
      ],
    };
  },
  beforeMount() {
    this.apiBaseUrl = process.env.VUE_APP_FEED_SERVICE_URL;
    if (this.$route.query.commentId) {
      this.reportedCommentId = this.$route.query.commentId;
    }

    if (!this.$route.params.feed) {
      this.$http
        .get(
          `${this.apiBaseUrl}/management/feedposts/${this.$route.params.id}`,
          {
            headers: {
              Authorization: this.$session.get("token"),
              uuid: this.$session.get("uuid"),
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            // console.log(res.data);
            this.feedData = res.data.data;
            // this.currentHideType = res.data.data.feedpost.hide;
            this.profileExchanges = res.data.data.profile_exchanges;

            if(res.data.data.feedpost.hide == "NONE") {
              this.currentHideType = "none";
            } else if(res.data.data.feedpost.hide == "CS") {
              this.currentHideType = "전체숨김"
            } else if(res.data.data.feedpost.hide == "REPORT") {
              this.currentHideType = "신고누적숨김"
            } else if(res.data.data.feedpost.hide == "OWN") {
              this.currentHideType = "작외숨"
            }

            // if (it.feedpost.content.text.length >= 10) {
            //   it.feedpost.content.text = it.feedpost.content.text.substring(0, 10) + "..."
            // }

            this.changedManageLikesCount =
              res.data.data.feedpost.total_count_manage_likes;
            this.changedFeedContent = res.data.data.feedpost.content.text;
            this.postId = res.data.data.feedpost.feedpost_id;
            if(res.data.data.feedpost.is_delete) {
              this.currentDeleteType = 'true';
            } else {
              this.currentDeleteType = 'false';
            }

            if (this.reportedCommentId) {
              this.getComments(res.data.data.feedpost.feedpost_id);
              this.$nextTick(() => {
                this.$bvModal.show('commentModal');
              });
            }
          }
        })
        .catch((err) => {
          alert(err);
        });
    } else {
      this.feedData = this.$route.params.feed;
      this.currentHideType = this.feedData.hide;
    }
  },
  methods: {
    getTimeStamp(created_at) {
      return this.$moment(created_at).format("YY/MM/DD_HH:mm");
    },
    openAdminUserPage(email) {
      window.open(
        `${process.env.VUE_APP_DJANGO_URL}/ko/yp/manage/service/admin/account/user/by-email/?email=${email}`
      );
    },
    openCallRoomPage(callRoom) {
      window.open(
        `${process.env.VUE_APP_DJANGO_URL}/ko/yp/manage/service/admin/voice/roomcallwaitingroom/${callRoom}/change/`
      );
    },
    changeHideType(type) {
      this.currentHideType = type
    },
    changeIsDelete(del) {
      this.currentDeleteType = del;
    },
    updateFeedContent() {
     

      let hideType = ''

      if(this.currentHideType == "none") {
        hideType = "NONE";
      } else if(this.currentHideType == "전체숨김") {
        hideType = "CS"
      } else if(this.currentHideType == "신고누적숨김") {
        hideType = "REPORT"
      } else if(this.currentHideType == "작외숨") {
        hideType = "OWN"
      }

      this.$http
        .put(
          `${this.apiBaseUrl}/management/feedposts/${this.feedData.feedpost.feedpost_id}`,
          {
            text: this.changedFeedContent,
            totalCountManageLikes: this.changedManageLikesCount,
            hide: hideType,
            isDelete: this.currentDeleteType == 'true' ? true : false
          },
          {
            headers: {
              Authorization: this.$session.get("token"),
              uuid: this.$session.get("uuid"),
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            alert("성공적으로 업데이트 되었습니다.");            
            this.$router.go();
          }
        })
        .catch((err) => {

          alert(`업데이트에 실패했어요.${err}`);
        });
        
    },
    deleteFeedContent() {
      this.$http
        .delete(`${this.apiBaseUrl}/management/feedposts/${this.postId}`, {
          headers: {
            Authorization: this.$session.get("token"),
            uuid: this.$session.get("uuid"),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            alert("success");
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    getComments(activityId) {
      console.log(activityId);
      this.$http
        .get(
          this.apiBaseUrl + `/management/feedposts/${activityId}/comments/`,
          {
            headers: {
              Authorization: this.$session.get("token"),
              uuid: this.$session.get("uuid"),
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            this.feedOriginId = activityId;
            console.log(res.data);
            this.filterComments(res.data.data.comments);
            console.log("AAA: ",res.data.data.comments);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    getHeader() {
      return {
        Authorization: this.$session.get("token"),
        uuid: this.$session.get("uuid"),
      }
    },
    commentCheckboxChange(comment_id) {
      if (this.selectedComments[comment_id] === 'accepted') {
        this.$delete(this.selectedComments, comment_id)
      } else {
        this.$set(this.selectedComments, comment_id, 'accepted')
      }
    },
    toggleSelectWholeComments() {
      if (Object.keys(this.selectedComments).length === this.comments.length) {
        this.selectedComments = {};
      } else {
        this.comments.forEach((comment) => {
          this.$set(this.selectedComments, comment.id, "accepted");
        })
      }
    },
    changecommentDropdownHideType(value) {
      this.commentDropdownHideType = value;
    },
    async hideCommentActionButton() {
      const commentIds = Object.keys(this.selectedComments).filter(
        (key) => this.selectedComments[key] === "accepted"
      );
      await this.$http
        .put(
          `${this.apiBaseUrl}/management/comments/batch`,
          {
            commentIds,
            data: {
              hide: this.hideCategory[this.commentDropdownHideType],
            },
          },
          {
            headers: this.getHeader()
          }
        )
        .then((res) => {
          if (res.status === 200) {
            alert("success");
            this.selectedComments = {};
            this.getComments(this.feedOriginId);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    filterComments(comments) {
      this.comments = [];
      this.selectedComments = {};
      comments.forEach((comment) => {
        let bigCommentList = [];
        if (comment.children.length > 0) {
          comment.children.forEach((bigComment) => {
            bigCommentList = [
              {
                comment: "┗",
                parent_id: comment.comment.comment_id,
                id: bigComment.comment.comment_id,
                uuid: bigComment.user.uuid,
                user: bigComment.user.email,
                content_type: bigComment.comment.content.type,
                content: bigComment.comment.content.text,
                contentUrl: bigComment.comment.content.url,
                contentDuration: bigComment.comment.content.duration,
                likesCount: bigComment.comment.total_count_likes,
                reportsCount: bigComment.comment.total_count_reports,
                hide: bigComment.comment.hide,
                is_delete: bigComment.comment.is_delete,
                created_at: this.$moment(bigComment.comment.created_at).format(
                  "YY/MM/DD_HH:mm"
                ),
              },
              ...bigCommentList,
            ];
          });
        }
        this.comments = [
          {
            comment: "origin",
            id: comment.comment.comment_id,
            uuid: comment.user.uuid,
            user: comment.user.email,
            content_type: comment.comment.content.type,
            content: comment.comment.content.text,
            contentUrl: comment.comment.content.url,
            contentDuration: comment.comment.content.duration,
            likesCount: comment.comment.total_count_likes,
            reportsCount: comment.comment.total_count_reports,
            hide: comment.comment.hide,
            is_delete: comment.comment.is_delete,
            created_at: this.$moment(comment.comment.created_at).format(
              "YY/MM/DD_HH:mm"
            ),
          },
          ...bigCommentList,
          ...this.comments,
        ];
      });
    },
    commentRowClass(item, type) {
      if (!item || type !== 'row') return null
      const isOrigin = item.comment === 'origin'
      const hasReport = item.reportsCount >= 1
      const isReported = this.reportedCommentId && String(item.id) === String(this.reportedCommentId)
      if (isReported && isOrigin) return 'table-warning origin-comment'
      if (isReported) return 'table-warning'
      if (isOrigin && hasReport) return 'table-warning origin-comment'
      if (hasReport) return 'table-warning'
      if (isOrigin) return 'comment-origin-row'
      return null
    },
    openFeedComment(userId, commentId) {
      const routeData = this.$router.resolve({
        name: "feedComment",
        params: { user_id: userId, comment_id: commentId },
      });
      window.open(routeData.href, "_blank");
    },
    openImagePreview(images) {
      this.previewImages = images;
      this.$bvModal.show('feedContentImagePreview');
    },
    formatDateTime(date) {
      if (!date) return;

      const newDate = new Date(date);

      const day = newDate.getDate();
      const month = newDate.getMonth() + 1;
      const year = newDate.getFullYear();
      let hours = newDate.getHours();
      let minutes = newDate.getMinutes();
      const ampm = hours >= 12 ? '오후' : '오전';

      hours = hours % 12;
      minutes = minutes < 10 ? `0${minutes}` : minutes;

      return `${year}년 ${month}월 ${day}일 ${hours}:${minutes} ${ampm} `
    }
  },
};
</script>

<style scoped>
.nameFields {
  font-weight: bold;
  text-align: right;
}

.feedData {
  text-align: left;
}

.profileExchangeHeader {
  width: 100%;
  padding: 13px 30px;
  background: #83ADC5;
  margin-top: 75px;
}

.profileExchangeHeader h1 {
  font-size: 22px;
  font-weight: 600;
  line-height: 27px;
  color: #FFF;
  text-align: left;
}

.clickableId {
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: #6C8FA7;
}


::v-deep .origin-comment {
  border-left: 3px solid #007bff !important;
}
</style>
